import { createAsyncThunk } from "@reduxjs/toolkit";
import type { HardwareBundle } from "types";
import { apiGet, apiPost } from "utilities/api";
import { HARDWARE_FOLDER_PATH, SCOPES } from "utilities/constants/constants";

export const fetchHardwareBundles = createAsyncThunk(
	"bundles/fetch",
	apiGet<{ [key: string]: HardwareBundle }>(
		(authConfig) => authConfig.DATA_LAKE_API_ENDPOINTS.GET_CUSTOMER_DATA(HARDWARE_FOLDER_PATH),
		[SCOPES.DATA_LAKE_READ],
	),
);

export const postHardwareBundle = createAsyncThunk(
	"bundles/post",
	apiPost<{ [key: string]: HardwareBundle }>(
		(authConfig) => authConfig.DATA_LAKE_API_ENDPOINTS.POST_CUSTOMER_DATA(HARDWARE_FOLDER_PATH),
		[SCOPES.DATA_LAKE_WRITE],
	),
);
